import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1feb210c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1feb210c')) {
      api.createRecord('1feb210c', component.options)
    } else {
      api.reload('1feb210c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1feb210c&", function () {
      api.rerender('1feb210c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26cl9JfAy4Ydw/JS/comp/ErrorMessage.vue"
export default component.exports